import React, { Fragment } from "react";

export default function App() {
  const arr = [
    {
      GYOSI: 1,
      MON: "강릉",
      TUE: "전산원",
      WED: "전산원2",
      THU: "",
      FRI: "전산원1"
    },
    {
      GYOSI: 2,
      MON: "강릉",
      TUE: "강릉원주",
      WED: "전산원2",
      THU: "",
      FRI: "전산원2"
    },
    {
      GYOSI: 3,
      MON: "강릉",
      TUE: "전산원",
      WED: "전산원2",
      THU: "전산원3",
      FRI: "전산원2"
    },
    {
      GYOSI: 4,
      MON: "강릉",
      TUE: "전산원",
      WED: "전산원2",
      THU: "전산원2",
      FRI: "전산원2"
    },
    {
      GYOSI: 5,
      MON: "인문대수업",
      TUE: "강릉원주",
      WED: "전산원2",
      THU: "전산원3",
      FRI: "전산원3"
    },
    {
      GYOSI: 6,
      MON: "인문대수업",
      TUE: "강릉원주",
      WED: "전산원1",
      THU: "전산원2",
      FRI: "전산원3"
    },
    {
      GYOSI: 7,
      MON: "",
      TUE: "",
      WED: "전산원2",
      THU: "전산원2",
      FRI: "전산원3"
    },
    {
      GYOSI: 8,
      MON: "인문대수업",
      TUE: "강릉원주",
      WED: "전산원2",
      THU: "전산원3",
      FRI: ""
    }
  ];

  let GYOSIArr = {};
  let MONArr = {};
  let TUEArr = {};
  let WEDArr = {};
  let THUArr = {};
  let FRIArr = {};
  
  const rowSpanMON = arr.reduce((result, item, key) => {
    if (GYOSIArr[item.MON] === undefined) {
      GYOSIArr[item.MON] = key;
      result[key] = 1;
    } else {
      const firstIndex = GYOSIArr[item.MON];
      if (
        firstIndex === key - 1 ||
        (item.MON === arr[key - 1].MON && result[key - 1] === 0)
      ) {
        result[firstIndex]++;
        result[key] = 0;
      } else {
        result[key] = 1;
        GYOSIArr[item.MON] = key;
      }
    }
    return result;
  }, []);

  const rowSpanTUE = arr.reduce((result, item, key) => {
    if (MONArr[item.TUE] === undefined) {
      MONArr[item.TUE] = key;
      result[key] = 1;
    } else {
      const firstIndex = MONArr[item.TUE];
      if (
        firstIndex === key - 1 ||
        (item.TUE === arr[key - 1].TUE && result[key - 1] === 0)
      ) {
        result[firstIndex]++;
        result[key] = 0;
      } else {
        result[key] = 1;
        MONArr[item.TUE] = key;
      }
    }
    return result;
  }, []);

  const rowSpanWED = arr.reduce((result, item, key) => {
    if (TUEArr[item.WED] === undefined) {
      TUEArr[item.WED] = key;
      result[key] = 1;
    } else {
      const firstIndex = TUEArr[item.WED];
      if (
        firstIndex === key - 1 ||
        (item.WED === arr[key - 1].WED && result[key - 1] === 0)
      ) {
        result[firstIndex]++;
        result[key] = 0;
      } else {
        result[key] = 1;
        TUEArr[item.WED] = key;
      }
    }
    return result;
  }, []);

  const rowSpanTHU = arr.reduce((result, item, key) => {
    if (WEDArr[item.THU] === undefined) {
      WEDArr[item.THU] = key;
      result[key] = 1;
    } else {
      const firstIndex = WEDArr[item.THU];
      if (
        firstIndex === key - 1 ||
        (item.THU === arr[key - 1].THU && result[key - 1] === 0)
      ) {
        result[firstIndex]++;
        result[key] = 0;
      } else {
        result[key] = 1;
        WEDArr[item.THU] = key;
      }
    }
    return result;
  }, []);

  const rowSpanFRI = arr.reduce((result, item, key) => {
    if (THUArr[item.FRI] === undefined) {
      THUArr[item.FRI] = key;
      result[key] = 1;
    } else {
      const firstIndex = THUArr[item.FRI];
      if (
        firstIndex === key - 1 ||
        (item.FRI === arr[key - 1].FRI && result[key - 1] === 0)
      ) {
        result[firstIndex]++;
        result[key] = 0;
      } else {
        result[key] = 1;
        THUArr[item.FRI] = key;
      }
    }
    return result;
  }, []);

  return (
    <div>
      <table border="1">
        <tr>
          <th>GYOSI</th>
          <th>MON</th>
          <th>TUE</th>
          <th>WED</th>
          <th>THU</th>
          <th>FRI</th>
        </tr>
        {arr.map((el, index) => (
          <tr key={index}>
            <td>{el.GYOSI}</td>
            {rowSpanMON[index] > 0 && <td rowSpan={rowSpanMON[index]}>{el.MON}</td>}
            {rowSpanTUE[index] > 0 && <td rowSpan={rowSpanTUE[index]}>{el.TUE}</td>}
            {rowSpanWED[index] > 0 && <td rowSpan={rowSpanWED[index]}>{el.WED}</td>}
            {rowSpanTHU[index] > 0 && <td rowSpan={rowSpanTHU[index]}>{el.THU}</td>}
            {rowSpanFRI[index] > 0 && <td rowSpan={rowSpanFRI[index]}>{el.FRI}</td>}
          </tr>
        ))}
      </table>
    </div>
  );
}